var React = require('react');

function Camera (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17.5 12.6929C17.5 14.0954 16.3812 15.2315 15 15.2315C13.6188 15.2315 12.5 14.0954 12.5 12.6929C12.5 11.2903 13.6188 10.1543 15 10.1543C16.3812 10.1543 17.5 11.2903 17.5 12.6929Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.8328 3.38424H27.5C28.9172 3.38424 30 4.48534 30 5.92283V19.4614C30 20.8148 28.9172 22 27.5 22H2.5C1.0828 22 0 20.8148 0 19.4614V5.92283C0 4.48375 1.0828 3.38424 2.5 3.38424H9.1656L10.8328 0H19.1656L20.8328 3.38424ZM9.16722 12.6929C9.16722 15.9931 11.75 18.6158 15 18.6158C18.25 18.6158 20.8328 15.9931 20.8328 12.6929C20.8328 9.39277 18.25 6.7701 15 6.7701C11.75 6.7701 9.16722 9.39277 9.16722 12.6929Z","fill":"currentColor","key":1})]);
}

Camera.defaultProps = {"width":"30","height":"22","viewBox":"0 0 30 22","fill":"none"};

module.exports = Camera;

Camera.default = Camera;
